export class GetDiscountListRequest {
    KeywordSearches: string[];
    PageNumber: number;
    ItemsPerPage: number;
    StatusFilter: number;
    Sorting: number;
}
